export const BASE_URL = 'https://pro.alphadevteam.com/api/tz/speakers';
